module.exports = __webpack_public_path__ + "img/KrantiSirNDTVRaftar.4ba52bb3.jpg";